import { render } from "./EditValidationTaskPage.vue?vue&type=template&id=0f333730&ts=true"
import script from "./EditValidationTaskPage.vue?vue&type=script&lang=ts"
export * from "./EditValidationTaskPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__